import { apiClient } from './client'
import { SavedReport, SavedReportParams } from '../../types/reports'

interface SavedReportsResponse {
  saved_reports: SavedReport[]
}

interface SavedReportResponse {
  saved_report: SavedReport
}

export const savedReportApi = {
  list: async (advertiser_id?: number): Promise<SavedReport[]> => {
    const qs = advertiser_id ? `?advertiser_id=${advertiser_id}` : ''
    const res = await apiClient.get<SavedReportsResponse>(`/saved_reports${qs}`)
    return res.saved_reports
  },

  get: async (id: number): Promise<SavedReport> => {
    const res = await apiClient.get<SavedReportResponse>(`/saved_reports/${id}`)
    return res.saved_report
  },

  create: async (payload: {
    name: string
    advertiser_id: number
    saved_params: SavedReportParams
  }): Promise<SavedReport> => {
    const res = await apiClient.post<SavedReportResponse>('/saved_reports', {
      saved_report: payload,
    })
    return res.saved_report
  },

  update: async (id: number, payload: { name?: string; saved_params?: SavedReportParams }): Promise<SavedReport> => {
    const res = await apiClient.patch<SavedReportResponse>(`/saved_reports/${id}`, {
      saved_report: payload,
    })
    return res.saved_report
  },

  destroy: async (id: number): Promise<void> => {
    await apiClient.delete(`/saved_reports/${id}`)
  },
}
